import lodash from 'lodash'
import React, { useMemo } from 'react'
import { ReactElement } from 'react'
import { useForm } from 'react-final-form'

// import NumberInputUpdate from '1stlog-ui/components/NumberInput/Update'
import {
  Label,
  useField,
} from '../../../../../../../1stlog-ui/src/components/Field'
import { useFieldArray } from '../../../../../../../1stlog-ui/src/components/FieldArray'
import NumberInput from '../../../../../../../1stlog-ui/src/components/NumberInput'
import { useProductSettings } from '../../../../Products'
import useOrderEntry from '../../../../useOrderEntry'

type TColiCountProps = {
  readonly?: boolean
  disable?: boolean
}

const ColiCount = (props: TColiCountProps): ReactElement => {
  const { readonly, disable } = props

  const form = useForm()

  const { preset } = useOrderEntry()

  const { maxColis } = useProductSettings()

  const { fields, meta } = useFieldArray('colis')
  const [colis, setColis] = useField('colis', { asState: true })

  const { push, pop } = fields

  const defaultColi = useMemo(() => {
    return {
      weight: preset?.defaultWeight ?? 1,
      width: 0,
      height: 0,
      length: 0,
    }
  }, [preset])

  const coliCount = useMemo(() => lodash.get(fields, 'length', 0), [fields])

  // this is done in getInitialValuesFromSettings
  // useEffect(() => {
  //   if (coliCount < 1) {
  //     setTimeout(() => push(defaultColi), 0)
  //   }
  // }, [coliCount])

  const onChange = (count: number): void => {
    if (count < 1 || count > 100) return
    const diff = count - coliCount
    setTimeout(
      () =>
        form.batch(() => {
          if (diff > 0) {
            for (let i = 0; i < Math.abs(diff); i++) {
              push(defaultColi)
            }
          } else {
            for (let i = coliCount; i > count; i--) {
              pop()
            }
          }
        }),
      0,
    )
  }

  if (maxColis === 1) {
    return <></>
  }

  return (
    <div>
      <div className="text-center">
        <div>
          <Label>{i18n.t('coli_count', 'Anzahl Colis')}</Label>
        </div>
        {(readonly || disable) && (
          <h4 className={!readonly ? 'mt-2' : 'mt-1'}>{coliCount}</h4>
        )}
      </div>
      {!readonly && !disable && (
        <NumberInput
          min={1}
          max={100}
          value={coliCount}
          // onKeyUp={onInputEnter}
          // id="tab_jump_colis"
          onChange={onChange}
        />
      )}
    </div>
  )
}

export default ColiCount
